export default "__VITE_ASSET__lhz2g8Ew__"